module.exports = __webpack_public_path__ + "img/user-viajes-3.7ae72216.svg";